// Map's ZOOM
export const INITIAL_MAP_ZOOM = 14;
